export default {
  lang: 'hi',
  dir: 'ltr',
  common: {
    ok: 'बचाना',
    cancel: 'रद्द करें',
    key_backspace: 'बैकस्पेस',
    key_del: 'हटायें',
    key_down: 'नीचे',
    key_up: 'ऊपर',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Show/hide more stroke tools',
    palette_info: 'रंग बदलने पर क्लिक करें, बदलाव भरने के क्लिक करने के लिए स्ट्रोक का रंग बदलने के लिए',
    zoom_level: 'बदलें स्तर ज़ूम',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identify the element',
    fill_color: 'बदलें का रंग भरना',
    stroke_color: 'बदलें स्ट्रोक रंग',
    stroke_style: 'बदलें स्ट्रोक डेश शैली',
    stroke_width: 'बदलें स्ट्रोक चौड़ाई',
    pos_x: 'X समकक्ष बदलें ',
    pos_y: 'Y समकक्ष बदलें',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: 'बदलें रोटेशन कोण',
    blur: 'Change gaussian blur value',
    opacity: 'पारदर्शिता बदलें',
    circle_cx: 'बदल रहा है चक्र cx समन्वय',
    circle_cy: 'परिवर्तन चक्र cy समन्वय है',
    circle_r: 'बदल रहा है चक्र त्रिज्या',
    ellipse_cx: 'बदलें दीर्घवृत्त है cx समन्वय',
    ellipse_cy: 'बदलें दीर्घवृत्त cy समन्वय है',
    ellipse_rx: 'बदल रहा है दीर्घवृत्त x त्रिज्या',
    ellipse_ry: 'बदल रहा है दीर्घवृत्त y त्रिज्या',
    line_x1: 'बदल रहा है लाइन x समन्वय शुरू',
    line_x2: 'बदल रहा है लाइन x समन्वय समाप्त',
    line_y1: 'बदलें रेखा y शुरू हो रहा है समन्वय',
    line_y2: 'बदलें रेखा y अंत है समन्वय',
    rect_height: 'बदलें आयत ऊंचाई',
    rect_width: 'बदलें आयत चौड़ाई',
    corner_radius: 'बदलें आयत कॉर्नर त्रिज्या',
    image_width: 'बदलें छवि चौड़ाई',
    image_height: 'बदलें छवि ऊँचाई',
    image_url: 'बदलें यूआरएल',
    node_x: 'नोड का x समकक्ष बदलें',
    node_y: 'नोड का y समकक्ष बदलें',
    seg_type: 'वर्ग प्रकार बदलें',
    straight_segments: 'सीधे वर्ग',
    curve_segments: 'घुमाव',
    text_contents: 'बदलें पाठ सामग्री',
    font_family_label: 'Font:',
    font_family: 'बदलें फ़ॉन्ट परिवार',
    font_size: 'फ़ॉन्ट का आकार बदलें',
    bold: 'मोटा पाठ',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'इटैलिक पाठ',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Main Menu',
    bkgnd_color_opac: 'पृष्ठभूमि का रंग बदल / अस्पष्टता',
    connector_no_arrow: 'No arrow',
    fitToContent: 'सामग्री के लिए फिट',
    fit_to_all: 'सभी सामग्री के लिए फिट',
    fit_to_canvas: 'फिट कैनवास को',
    fit_to_layer_content: 'फिट परत सामग्री के लिए',
    fit_to_sel: 'चयन के लिए फिट',
    align_relative_to: 'संरेखित करें रिश्तेदार को ...',
    relativeTo: 'रिश्तेदार को:',
    page: 'पृष्ठ',
    largest_object: 'सबसे बड़ी वस्तु',
    selected_objects: 'निर्वाचित वस्तुओं',
    smallest_object: 'छोटी से छोटी वस्तु',
    new_doc: 'नई छवि',
    open_doc: 'छवि खोलें',
    export_img: 'Export',
    save_doc: 'सहेजें छवि',
    import_doc: 'Import SVG',
    align_to_page: 'Align Element to Page',
    align_bottom: 'तलमेंपंक्तिबद्धकरें',
    align_center: 'मध्य में समंजित करें',
    align_left: ' पंक्तिबद्ध करें',
    align_middle: 'मध्य संरेखित करें',
    align_right: 'दायाँपंक्तिबद्धकरें',
    align_top: 'शीर्षमेंपंक्तिबद्धकरें',
    mode_select: 'उपकरण चुनें',
    mode_fhpath: 'पेंसिल उपकरण',
    mode_line: 'लाइन उपकरण',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'नि: शुल्क हाथ आयत',
    mode_ellipse: 'दीर्घवृत्त',
    mode_circle: 'वृत्त',
    mode_fhellipse: 'नि: शुल्क हाथ दीर्घवृत्त',
    mode_path: 'Path Tool',
    mode_text: 'पाठ उपकरण',
    mode_image: 'छवि उपकरण',
    mode_zoom: 'ज़ूम उपकरण',
    no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
    undo: 'पूर्ववत करें',
    redo: 'फिर से करें',
    tool_source: 'स्रोत में बदलाव करें',
    wireframe_mode: 'रूपरेखा मोड',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'समूह तत्वों',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'पथ में बदलें',
    reorient_path: 'पथ को नई दिशा दें',
    ungroup: 'अंश को समूह से अलग करें',
    docprops: 'दस्तावेज़ गुण',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'नीचे ले जाएँ',
    move_top: 'ऊपर ले जाएँ',
    node_clone: 'नोड क्लोन',
    node_delete: 'नोड हटायें',
    node_link: 'कड़ी नियंत्रण बिंदु',
    add_subpath: 'Add sub-path',
    openclose_path: 'Open/close sub-path',
    source_save: 'बचाना',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'परत',
    layers: 'Layers',
    del: 'परत हटाएँ',
    move_down: 'परत नीचे ले जाएँ',
    new: 'नई परत',
    rename: 'परत का नाम बदलें',
    move_up: 'परत ऊपर ले जाएँ',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'अंश को ले जाएँ:',
    move_selected: 'चयनित अंश को दूसरी परत पर  ले जाएँ'
  },
  config: {
    image_props: 'छवि के गुण',
    doc_title: 'शीर्षक',
    doc_dims: 'कैनवास आयाम',
    included_images: 'शामिल छवियाँ',
    image_opt_embed: 'एम्बेड डेटा (स्थानीय फ़ाइलें)',
    image_opt_ref: 'फाइल के संदर्भ का प्रयोग',
    editor_prefs: 'संपादक वरीयताएँ',
    language: 'भाषा',
    background: 'संपादक पृष्ठभूमि',
    editor_img_url: 'Image URL',
    editor_bg_note: 'नोट: पृष्ठभूमि छवि के साथ नहीं बचायी जाएगी',
    select_predefined: 'चुनें पूर्वनिर्धारित:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'अमान्य मूल्य',
    noContentToFitTo: 'कोई सामग्री फिट करने के लिए उपलब्ध नहीं',
    dupeLayerName: 'इस नाम कि परत पहले से मौजूद है !',
    enterUniqueLayerName: 'कृपया परत का एक अद्वितीय नाम डालें',
    enterNewLayerName: 'कृपया परत का एक नया नाम डालें',
    layerHasThatName: 'परत का पहले से ही यही नाम है',
    QmoveElemsToLayer: "चयनित अंश को परत '%s' पर ले जाएँ ?",
    QwantToClear: 'क्या आप छवि साफ़ करना चाहते हैं?\nयह आपके उन्डू  इतिहास को भी मिटा देगा!',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'आपके एस.वी.जी. स्रोत में त्रुटियों थी.\nक्या आप मूल एस.वी.जी स्रोत पर वापिस जाना चाहते हैं?',
    QignoreSourceChanges: 'एसवीजी स्रोत से लाये बदलावों को ध्यान न दें?',
    featNotSupported: 'सुविधा असमर्थित है',
    enterNewImgURL: 'नई छवि URL दर्ज करें',
    defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
    loadingImage: 'Loading image, please wait...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
